import { AUTH_USER_KEY } from '@/lib/constants/authentication'

const clearCurrentUser = () => localStorage.removeItem(AUTH_USER_KEY)

export default clearCurrentUser
